import { IBodyAddSubstitutionPartParams } from '@/modules/adjusterReportModules/Insurer-information/queries/addBodySubstitutionPart/addBodySubstitutionPartQuery.type';
import { addBodySubstitutionPartQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/addBodySubstitutionPart/addBodySubstitutionPartQueryFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const addBodySubstitutionPartQueryOption = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  IBodyAddSubstitutionPartParams
> => ({
  mutationKey: ['PatchBodyCertificationQueryParamsType'],
  mutationFn: (params: IBodyAddSubstitutionPartParams) =>
    addBodySubstitutionPartQueryFunction(params),
});
